<template>
  <div class="simple-layout">

    <h1 class="visuallyhidden">BackupMonkey</h1>

    <header class="headerbar">
      <div class="logo">
        <a href="https://www.backupmonkey.io">
          <img src="/images/logomark/bm_logomark--white.svg" alt="Go to backupmonkey.io"/>
        </a>
      </div>
    </header>

    <main>
      <div class="maincontent fullwindow">
        <router-view></router-view>
      </div>
    </main>

  </div>
</template>

<script>

export default {
  name: 'SimpleLayout'
}
</script>
